/**
 * Paywall-related types for subscription management
 */

/**
 * Subscription status types
 */
export enum SubscriptionStatus {
  ACTIVE = 'active',
  CANCELLED = 'cancelled',
  EXPIRED = 'expired',
  GRACE_PERIOD = 'grace_period',
  TRIAL = 'trial',
  PAST_DUE = 'past_due',
}

/**
 * Subscription data returned from API
 */
export interface Subscription {
  id: string;
  status: SubscriptionStatus;
  planName: string;
  amount: number;
  currency: string;
  currentPeriodStart: string;
  currentPeriodEnd: string;
  cancelledAt: string | null;
  gracePeriodEndsAt: string | null;
  shopifyAppUrl: string | null;
  isShopifySubscription: boolean;
}

/**
 * Paywall state in the API response
 */
export interface PaywallData {
  isBlocked: boolean;
  subscription: Subscription | null;
  message?: string;
  gracePeriodDaysRemaining?: number;
}

/**
 * Paywall reason - why the user is being paywalled
 */
export enum PaywallReason {
  SUBSCRIPTION_EXPIRED = 'subscription_expired',
  SUBSCRIPTION_CANCELLED = 'subscription_cancelled',
  PAYMENT_FAILED = 'payment_failed',
  NO_SUBSCRIPTION = 'no_subscription',
}

/**
 * Internal paywall state for the store
 */
export interface PaywallState {
  isBlocked: boolean;
  isVisible: boolean;
  subscription: Subscription | null;
  reason: PaywallReason | null;
  gracePeriodDaysRemaining: number | null;
  message: string | null;
}

/**
 * Actions for the paywall store
 */
export interface PaywallActions {
  showPaywall: (data: PaywallData, reason: PaywallReason) => void;
  reset: () => void;
}
